import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import Loader from "./Loader"
import reportWebVitals from './reportWebVitals';
import Home from './Home';
import About from "./About"

ReactDOM.render(
  <React.StrictMode>
    
    <Loader />
    
  </React.StrictMode>,
  document.getElementById('root')
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
